import OverlayTile from './OverlayTile'
import OverlayTileHeading from './OverlayTileHeading'
import OverlayWorkspaceList from './OverlayWorkspaceList'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

export default class OverlayWorkspaceTile extends Component {
  static propTypes = {
    workspaces: PropTypes.array.isRequired
  }

  render() {
    const { workspaces } = this.props

    return (
      <OverlayTile count={workspaces.length}>
        <OverlayTileHeading icon="folder-open" title="Workspaces" />
        <OverlayWorkspaceList workspaces={workspaces} />
      </OverlayTile>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/OverlayWorkspaceTile.js